export default __webpack_public_path__ + "static/media/4.3e49055d.png";